import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import clsx from 'clsx'
import Image from 'next/image'
import { intl } from 'src/i18n'
import { getActiveWatchlist } from 'src/redux/selectors'
import {
  addWatchListItem,
  getWatchlistTabs,
  deleteWatchListItem,
} from 'src/redux/thunks'
import styles from './styles.module.scss'

type Props = {
  code: string
  isMobile?: boolean
}

export const AddToWatchlist = (props: Props) => {
  const { code, isMobile } = props
  const dispatch = useDispatch()
  const tabActive = useSelector(getActiveWatchlist)
  const [inWatchlist, setInWatchlist] = useState(false)

  useEffect(() => {
    dispatch(getWatchlistTabs())
  }, [dispatch])

  useEffect(() => {
    const { data } = tabActive || []
    setInWatchlist(data?.find(item => item === code))
  }, [code, tabActive])

  const handleAddRemoveItem = code => {
    if (inWatchlist) {
      dispatch(deleteWatchListItem(code))
    } else {
      dispatch(addWatchListItem(code))
    }
  }

  return (
    <div
      className={styles.addToWatchlist}
      onClick={() => handleAddRemoveItem(code)}
    >
      <div
        className={clsx(styles.iconContainer, {
          [styles.inWatchlist]: inWatchlist,
        })}
      >
        <Image
          src='/assets/icons/icon-star.svg'
          width='16'
          height='16'
          alt='Arrow icon'
        />
      </div>
      {!isMobile && (
        <span>
          {inWatchlist
            ? intl.t('coinDetails.addToWatchList.remove')
            : intl.t('coinDetails.addToWatchList.add')}
        </span>
      )}
    </div>
  )
}

export default AddToWatchlist
